import React from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE, RECORD, SETTINGS } from 'pathnames.js';

// GLOBAL COMPONENTS
import { checkRole, makePath } from 'functions';

// GLOBAL HELPERS
import { getListData } from 'helpers/getListData';

// GLOBAL COMPONENTS
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table';
import Title from 'parts/title/Title';
import Sprite from 'core/tools/Sprite';
import Button from 'core/tools/Button';

// LOCAL COMPONENTS
import DealershipsCell from '../parts/DealershipsCell';

// LOCAL VARIABLES
import { COLUMNS } from 'columns';
import { STORE_OPTION_KEYS } from '../variables';

// MAIN COMPONENT
const List = () => {
  return (
    <Main>
      <Title title="Vendors" tools={<Title.AddRecord label="Vendors" />} />
      <Filters>
        <Filters.Button.Active name="is_active" />
        <Filters.Button.Global name="is_global" numeric={false} />
        <Filters.Select name="make_dealer_id_list" lookup="storesByDealerGroup" optionKeys={STORE_OPTION_KEYS} />
        <Filters.Search name="vendor_name" placeholder="Search by vendor name" />
        <Filters.Reset />
      </Filters>
      <Table mobilePreviewKeys={['vendor_name', 'is_active']} />
    </Main>
  );
};

// EXPORT
export default getListData(List, {
  key: 'vendors',
  path: makePath(INTERFACE.settings, SETTINGS.vendors),
  fetchArgs: {
    endpoint: ENDPOINTS.admin.vendor.list
  },
  columns: [
    {
      key: 'vendor_name',
      label: 'Vendor',
      width: 200
    },
    {
      key: 'make_dealer_id_list',
      label: 'Dealerships',
      component: DealershipsCell
    },
    {
      ...COLUMNS.global,
      component: p => <Table.Boolean {...p} value={{ true: 1, false: 0 }[p.value]} />,
      tooltip: 'Global vendors are available to all dealers.'
    },
    {
      ...COLUMNS.active,
      tooltip: 'Only active vendors will be available while adding inventory.'
    },
    COLUMNS.updatedOn,
    COLUMNS.updatedBy,
    {
      key: 'dsl_vendor_id',
      label: '',
      width: 55,
      className: 'text-center',
      component: ({ row: { original } = {}, value }) => {
        return checkRole(['salesManager', 'salesManagerPlus']) && original.is_global ? (
          <Sprite use="lock-solid" fill="gray-600" className="mx-auto" />
        ) : (
          <Button.Link icon="edit" label="Edit" to={makePath(window.location.pathname, RECORD.edit, value)} />
        );
      }
    }
  ]
});
